import { Stack, TextField, Typography } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { MAX_BARCODE_LENGTH, validateBarcodeLength } from '../barcodeRange'
import type { BarcodeSettingForm } from './barcodeSettingForm'

export const Length = () => {
  const { control, getValues, trigger } = useFormContext<BarcodeSettingForm>()

  return (
    <Stack spacing={1}>
      <Typography
        variant="body2"
        sx={{ fontWeight: 'bold', color: 'text.primary' }}
      >
        読み取る桁数
      </Typography>
      <Controller
        name="length"
        control={control}
        rules={{
          required: '必須です',
          min: { value: 1, message: '1以上を入力してください' },
          validate: length =>
            validateBarcodeLength({
              startPosition: getValues('startPosition'),
              length,
            }) ?? true,
        }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            type="number"
            slotProps={{ htmlInput: { max: MAX_BARCODE_LENGTH, min: 1 } }}
            fullWidth
            error={!!error}
            helperText={error?.message}
            sx={{ bgcolor: 'white' }}
            onChange={e => {
              field.onChange(Number(e.target.value))
              void trigger(['startPosition', 'length'])
            }}
          />
        )}
      />
    </Stack>
  )
}
